import { Injectable } from '@angular/core';
import { IEffect } from '@ordersnproducts/modules/shared/modules/dynamic-effects/effect.interface';
import { AdtUnitsActionTypes, FetchAdtUnitsProductAction, LoadAdtUnitsOfProductAction } from '../actions/units.actions';
import { createEffect, Actions, ofType } from '@ngrx/effects';
import { catchError, map, switchMap } from 'rxjs/operators';
import { Action } from '@ngrx/store';
import { ProductService, UnitsReqV4, UnitsResponseV4 } from '@cemex-core/cmx-api';
import { Observable, of } from 'rxjs';

/**
 * Effects for adt units
 */
@Injectable()
export class AdtUnitsEffects implements IEffect {
  /**
   * Fetches unit products
   */

  adtFetchUnitsV4$: Observable<Action | Action[]> = createEffect(() =>
    this.actions$.pipe(
      ofType(AdtUnitsActionTypes.FETCH_UNITS_BY_PRODUCT),
      switchMap((action: FetchAdtUnitsProductAction) => {
        const payload = { productCode: action.payload } as UnitsReqV4;
        return this.productsService.getUnitsV4(payload).pipe(
          map((response: UnitsResponseV4) => {
            const productCode = action.payload.replace(/^0+/, '');
            const units = response.units;
            return new LoadAdtUnitsOfProductAction({ units, productCode });
          }),
          catchError(() => of(new LoadAdtUnitsOfProductAction(null))),
        );
      }),
    ),
  );

  constructor(
    private actions$: Actions,
    private productsService: ProductService,
  ) {}
}
